(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const ensureCollectionHeadingBMW = () => {
    const heading = document.querySelector('.product-grid-container h1, .product-grid-container .h1, main h1');
    if (!heading) return;
    const current = (heading.textContent || '').trim();
    if (!current) return;
    if (current === 'Productos') {
      heading.textContent = 'Productos BMW';
    }
  };

  let collectionPatchInitialized = false;
  let collectionCardsObserver = null;

  const parseCompatibilityValues = (rawText) => {
    if (!rawText) return [];

    const normalized = rawText
      .replace(/\s+/g, ' ')
      .replace(/\bCódigo OEM:\b/gi, ' ')
      .replace(/\bCodigo OEM:\b/gi, ' ')
      .replace(/\bCompatibilidad:\b/gi, ' ')
      .replace(/\bcompatibilidad:\b/gi, ' ')
      .replace(/\bMaterial\b/gi, ' ')
      .replace(/\bColor\b/gi, ' ')
      .replace(/\bSKU\b/gi, ' ')
      .trim();

    const directMatches = [...normalized.matchAll(/\b(?:2002|E\d{2,3}|M\d{2,3})\b/gi)].map((match) => match[0].trim());
    if (directMatches.length > 0) {
      return Array.from(new Set(directMatches));
    }

    return [];
  };

  const populateCompatibilityFilter = () => {
    const select = document.getElementById('collection-compatibility-filter');
    if (!select) return;

    const currentValue = select.value || '';
    const values = new Set();

    document.querySelectorAll('.product-grid__item[data-compatibility]').forEach((item) => {
      const raw = (item.getAttribute('data-compatibility') || '').trim();
      const parsed = parseCompatibilityValues(raw);
      parsed.forEach((value) => values.add(value));
    });

    const sortedValues = Array.from(values).sort((a, b) => a.localeCompare(b, 'es', { numeric: true }));
    const previousValue = currentValue;
    const baseOptions = '<option value="">Todas las compatibilidades</option>';

    if (select.innerHTML !== baseOptions && sortedValues.length > 0) {
      select.innerHTML = baseOptions;
      sortedValues.forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        if (value === previousValue) option.selected = true;
        select.appendChild(option);
      });
    }

    if (sortedValues.length === 0) {
      select.innerHTML = '<option value="">Todas las compatibilidades</option>';
    }

    if (previousValue && !sortedValues.includes(previousValue)) {
      select.value = '';
    }
  };

  const applyCollectionFilters = () => {
    const familySelect = document.getElementById('collection-family-filter');
    const compatibilitySelect = document.getElementById('collection-compatibility-filter');
    const productItems = document.querySelectorAll('.product-grid__item');

    if (!familySelect && !compatibilitySelect) return;

    const selectedFamily = familySelect ? (familySelect.value || '') : '';
    const selectedCompatibility = compatibilitySelect ? (compatibilitySelect.value || '') : '';
    let visibleCount = 0;

    productItems.forEach((item) => {
      const familyMatches = !selectedFamily || (item.getAttribute('data-family') || '').trim() === selectedFamily;
      const compatibilityValues = parseCompatibilityValues(item.getAttribute('data-compatibility') || '');
      const compatibilityMatches = !selectedCompatibility || compatibilityValues.includes(selectedCompatibility);
      const shouldShow = familyMatches && compatibilityMatches;
      item.style.display = shouldShow ? '' : 'none';
      if (shouldShow) visibleCount += 1;
    });

    const emptyState = document.querySelector('.collection-filter-empty-state');
    if (emptyState) {
      emptyState.style.display = visibleCount === 0 ? 'block' : 'none';
    }
  };

  window.applyCollectionFilters = applyCollectionFilters;

  const bindCollectionFilterHandlers = () => {
    const familySelect = document.getElementById('collection-family-filter');
    const compatibilitySelect = document.getElementById('collection-compatibility-filter');

    if (familySelect && !familySelect.dataset.boundFilter) {
      familySelect.dataset.boundFilter = 'true';
      familySelect.addEventListener('change', () => applyCollectionFilters());
      familySelect.onchange = () => applyCollectionFilters();
    }

    if (compatibilitySelect && !compatibilitySelect.dataset.boundFilter) {
      compatibilitySelect.dataset.boundFilter = 'true';
      compatibilitySelect.addEventListener('change', () => applyCollectionFilters());
      compatibilitySelect.onchange = () => applyCollectionFilters();
    }
  };

  const patchCollectionCard = (item) => {
    if (!(item instanceof Element)) return;
    if (!item.matches('.product-grid__item[data-vendor][data-family]')) return;

    const content = item.querySelector('.product-card__content');
    if (!content) return;

    const vendor = (item.getAttribute('data-vendor') || '').trim();
    const family = (item.getAttribute('data-family') || '').trim();
    const galleryTarget = item.querySelector('.card-gallery');
    let meta = item.querySelector('.collection-card-meta');
    const shouldMoveMetaAfterGallery = meta && galleryTarget && meta.parentNode !== galleryTarget.parentNode;

    if (!meta && !vendor && !family) return;

    if (!meta) {
      meta = document.createElement('div');
      meta.className = 'collection-card-meta';

      if (vendor) {
        const vendorEl = document.createElement('p');
        vendorEl.className = 'collection-card-meta__vendor';
        vendorEl.textContent = vendor;
        meta.appendChild(vendorEl);
      }

      if (family) {
        const familyEl = document.createElement('p');
        familyEl.className = 'collection-card-meta__family';
        familyEl.textContent = family;
        meta.appendChild(familyEl);
      }

      if (!vendor && !family) return;
    }

    if (galleryTarget && galleryTarget.parentNode) {
      const currentParent = meta.parentNode;
      const isAlreadyAfterGallery =
        currentParent === galleryTarget.parentNode && meta.previousElementSibling === galleryTarget;
      if (!isAlreadyAfterGallery || shouldMoveMetaAfterGallery) {
        galleryTarget.parentNode.insertBefore(meta, galleryTarget.nextSibling);
      }
    } else if (!meta.parentNode) {
      content.prepend(meta);
    }

    const compatibilityText = (item.getAttribute('data-compatibility') || '').trim();
    let oemValue = '';
    let compatibilityValue = '';

    if (compatibilityText.includes('Compatibilidad:')) {
      compatibilityValue = compatibilityText.split('Compatibilidad:').pop() || '';
    } else if (compatibilityText.includes('compatibilidad:')) {
      compatibilityValue = compatibilityText.split('compatibilidad:').pop() || '';
    } else {
      const codes = [...compatibilityText.matchAll(/\bE\d{2,3}\b/g)].map((m) => m[0]);
      if (codes.length > 0) {
        compatibilityValue = Array.from(new Set(codes)).join(', ');
      }
    }

    if (compatibilityValue) {
      compatibilityValue = compatibilityValue
        .split('Código OEM:')[0]
        .split('Codigo OEM:')[0]
        .split('Material')[0]
        .split('Color')[0]
        .split('SKU')[0]
        .trim();
    }
    if (compatibilityText.includes('Código OEM:')) {
      oemValue = compatibilityText.split('Código OEM:').pop() || '';
    } else if (compatibilityText.includes('Codigo OEM:')) {
      oemValue = compatibilityText.split('Codigo OEM:').pop() || '';
    }
    if (oemValue) {
      oemValue = oemValue
        .split('Compatibilidad')[0]
        .split('Material')[0]
        .split('Color')[0]
        .split('SKU')[0]
        .trim();
    }

    const descriptionTarget =
      item.querySelector('a.contents.user-select-text') ||
      item.querySelector('.product-card__title') ||
      item.querySelector('.product-grid-view-zoom-out--details');

    if (oemValue && !item.querySelector('.collection-card-meta__oem')) {
      const oem = document.createElement('p');
      oem.className = 'collection-card-meta__oem';
      oem.textContent = `OEM: ${oemValue}`;

      const priceTarget = item.querySelector('product-price, .price');
      if (descriptionTarget && descriptionTarget.parentNode) {
        descriptionTarget.parentNode.insertBefore(oem, descriptionTarget.nextSibling);
      } else if (priceTarget && priceTarget.parentNode) {
        priceTarget.parentNode.insertBefore(oem, priceTarget);
      } else {
        content.append(oem);
      }
    }

    if (compatibilityValue && !item.querySelector('.collection-card-meta__compatibility')) {
      const compatibility = document.createElement('p');
      compatibility.className = 'collection-card-meta__compatibility';
      compatibility.textContent = `Compatibilidad: ${compatibilityValue}`;

      const oemTarget = item.querySelector('.collection-card-meta__oem');
      if (oemTarget && oemTarget.parentNode) {
        oemTarget.parentNode.insertBefore(compatibility, oemTarget);
      } else if (descriptionTarget && descriptionTarget.parentNode) {
        descriptionTarget.parentNode.insertBefore(compatibility, descriptionTarget.nextSibling);
      } else {
        const priceTarget = item.querySelector('product-price, .price');
        if (priceTarget && priceTarget.parentNode) {
          priceTarget.parentNode.insertBefore(compatibility, priceTarget);
        } else {
          content.append(compatibility);
        }
      }
    }
  };

  const injectVendorFamilyInCollectionCards = (root = document) => {
    const items = root.querySelectorAll('.product-grid__item[data-vendor][data-family]');
    items.forEach((item) => patchCollectionCard(item));
  };

  const observeCollectionGridCards = () => {
    if (collectionCardsObserver) return;

    collectionCardsObserver = new MutationObserver((mutations) => {
      let addedProductCards = false;
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('.product-grid__item')) {
            patchCollectionCard(node);
            addedProductCards = true;
          }
          node.querySelectorAll?.('.product-grid__item').forEach((item) => {
            patchCollectionCard(item);
            addedProductCards = true;
          });
        }
      }

      if (addedProductCards) {
        populateCompatibilityFilter();
        applyCollectionFilters();
      }
    });

    collectionCardsObserver.observe(document.body, { childList: true, subtree: true });
  };

  const runCollectionPatch = () => {
    if (collectionPatchInitialized) return;
    collectionPatchInitialized = true;

    ensureCollectionHeadingBMW();
    populateCompatibilityFilter();
    bindCollectionFilterHandlers();
    applyCollectionFilters();
    injectVendorFamilyInCollectionCards();
    observeCollectionGridCards();
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      runCollectionPatch();
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
